import { fetch } from '@/plugin/axiosNoLogin'
const serverName = '/maintain'

export function getUseUnit(params) {
  return fetch({
    url: serverName + '/api/propertyUnitInfo',
		method: 'GET',
		params
  })
}